export default {
  title: 'Nuevo item',
  title_edit: 'Editando item',
  'sections.basicInfo': 'Información básica',
  'sections.controlInfo': 'Datos de control',
  'sections.stockInfo': 'Información de inventario',
  'sections.buyInfo': 'Información de compra',
  'sections.sellInfo': 'Información de venta',
  'sections.othersInfo': 'Otra información',
  'fields.name': 'Nombre',
  'fields.code': 'Código del producto',
  'fields.subCategory': 'Subcategoría',
  'fields.brand': 'Marca',
  'fields.model': 'Modelo',
  'fields.supplier': 'Proveedor',
  'fields.sizeUnit': 'Unidad de medida',
  'fields.description': 'Descripción',
  'fields.enabled': 'Activo',
  'fields.amount': 'Cantidad en inventario',
  'fields.minAmount': 'Inventario mínimo',
  'fields.maxAmount': 'Inventario máximo',
  'fields.criticalAmount': 'Volumen crítico',
  'fields.warningAmount': 'Volumen alerta',
  'fields.notificationEmails': 'Correos electrónicos de alerta',
  'fields.purchasePrice': 'Precio de costo',
  'fields.purchaseTax': 'Impuestos',
  'fields.currency': 'Moneda',
  'fields.salesPrice': 'Precio de venta',
  'fields.maxDiscount': 'Descuento máximo permitido',
  'fields.salesTax': 'Impuestos sobre ventas',
  'fields.barCode': 'Código de barras',
  'fields.notes': 'Observaciones',
  'fields.images': 'Imágenes',
  'fields.addFile': 'Agregar Archivo',
  'validation.required': 'Campo obligatorio',
  'validation.amountGreaterThanZero': 'La cantidad debe ser mayor que cero',
  'validation.invalidEmails': 'Uno o más correos electrónicos inválidos',
  'validation.duplicateEmails': 'Uno o más correos electrónicos duplicados',
  'bulkTransfer.title': 'Transferencias',
  'bulkTransfer.fields.status': 'Estado',
  'bulkTransfer.fields.item': 'Item',
  'bulkTransfer.fields.operation': 'Operación',
  'bulkTransfer.fields.user': 'Usuario',
  'bulkTransfer.fields.place': 'Local',
  'bulkTransfer.fields.amount': 'Cantidad',
  'bulkTransfer.validation.required': 'Campo obligatorio',
  'bulkTransfer.validation.amountNotNegative': 'La cantidad no puede ser menor que cero',
  'bulkTransfer.validation.amountGreaterThanZero': 'La cantidad debe ser mayor que cero',
  'bulkTransfer.actions.execute': 'Ejecutar',
  'bulkTransfer.actions.close': 'Cerrar',
  'statusTag.pending': 'Pendiente',
  'statusTag.success': 'Éxito',
  'statusTag.error': 'Error',
  'statusTag.insufficientAmount': 'Cantidad insuficiente',
  'statusTag.amountGreaterThanZero': 'La cantidad debe ser mayor que cero',
  'statusTag.genericError': 'Error genérico',
  'tooltip.item': 'Item',
  'tooltip.amount': 'Cantidad',
  'tooltip.operation': 'Operación',
  'tooltip.error': 'Error'
}
